module.exports = __webpack_public_path__ + "img/related-post-03.d4d8dbe3.jpg";